module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cb-body__wrap"
  }, [_c('div', {
    staticClass: "cb-body__content"
  }, [(!_vm.editMode && _vm.skip_cart) ? [_c('cart-fixed', {
    attrs: {
      "edit-order": true,
      "nav-icon": 'right'
    }
  })] : _vm._e(), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('div', {
    staticClass: "cb-section",
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.submit()
      }
    }
  }, [_vm._l((_vm.config_in_twos), function(arr, index) {
    return [(arr.length == 2) ? _c('div', {
      staticClass: "cb-field__group",
      class: [{
        'cb-field--top': index == 0
      }, {
        'cb-field--bottom': (_vm.config_in_twos.length - 1) == index
      }]
    }, [(arr[0].type) ? _c(_vm.componentName(arr[0].type), {
      tag: "component",
      staticClass: "cb-field__left",
      attrs: {
        "siblingError": _vm.showSiblingError(index, 1),
        "name": arr[0].name
      },
      on: {
        "informError": function($event) {
          _vm.informError(index, 0)
        },
        "clearError": function($event) {
          _vm.clearError(index, 0)
        }
      }
    }) : _vm._e(), _vm._v(" "), (arr[1].type) ? _c(_vm.componentName(arr[1].type), {
      tag: "component",
      staticClass: "cb-field__right",
      attrs: {
        "siblingError": _vm.showSiblingError(index, 0),
        "name": arr[1].name
      },
      on: {
        "informError": function($event) {
          _vm.informError(index, 1)
        },
        "clearError": function($event) {
          _vm.clearError(index, 1)
        }
      }
    }) : _vm._e()], 1) : (arr.length == 1 && arr[0].type != 'hidden') ? _c('div', {
      staticClass: "cb-field__group",
      class: [{
        'cb-field--top': index == 0
      }, {
        'cb-field--bottom': (_vm.config_in_twos.length - 1) == index
      }]
    }, [(arr[0].type) ? _c(_vm.componentName(arr[0].type), {
      tag: "component",
      attrs: {
        "name": arr[0].name
      }
    }) : _vm._e()], 1) : _vm._e()]
  })], 2)], 2), _vm._v(" "), _c('div', {
    staticClass: "cb-body__footer"
  }, [_c('cb-notes', {
    attrs: {
      "custom-class": 'cb-section',
      "type": 'info',
      "message": _vm.accountNote
    }
  }), _vm._v(" "), _c('cb-button', {
    attrs: {
      "custom-class": 'primary',
      "show-loader": _vm.showLoader
    },
    on: {
      "next": function($event) {
        _vm.submit()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.buttonTxt) + "\n        ")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a648bf30"}!./src/components/collections/templates/AccountTemplate.html
// module id = 605
// module chunks = 66